// storeInfoController
import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './storeInfo.json';

const queryAdvanceSearchOptions = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['storeInfoController/queryAdvanceSearchOptions'].success.default)));
};

const queryMRTCompany = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['storeInfoController/queryMRTCompany'].success.default)));
};

const queryNearbyStore = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['storeInfoController/queryNearbyStore'].success.default)));
};

const queryStoreArea = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['storeInfoController/queryStoreArea'].success.default)));
};

export const handlers = [
  rest.post(
    getApiEndpoint('storeInfoController/queryAdvanceSearchOptions'),
    withScenario(withAuthCheck(queryAdvanceSearchOptions))
  ),
  rest.post(getApiEndpoint('storeInfoController/queryMRTCompany'), withScenario(withAuthCheck(queryMRTCompany))),
  rest.post(getApiEndpoint('storeInfoController/queryNearbyStore'), withScenario(withAuthCheck(queryNearbyStore))),
  rest.post(getApiEndpoint('storeInfoController/queryStoreArea'), withScenario(withAuthCheck(queryStoreArea))),
];
